<template>
  <Modal
    :id="modalId"
    modal-class="small"
  >
    <template #title>
      {{ $t('connexion.etablissement-introuvable-modal-title') }}
    </template>
    <template #subtitle>
      <p class="text-regular">
        {{ $t('connexion.etablissement-introuvable-modal-subtitle') }}
      </p>
    </template>
    <template #content>
      <p class="text-regular">
        {{ $t('connexion.etablissement-introuvable-modal-content') }}
      </p>
    </template>
    <template #footer>
      <div class="etablissement-introuvable-footer">
        <ButtonClassic
          variant="ghost"
          color="secondary"
          :label="$t('connexion.contacter-par-courriel')"
          @click="openMailto()"
        />
        <ButtonClassic
          variant="solid"
          color="primary"
          :label="$t('action.fermer')"
          @click="close"
        />
      </div>
    </template>
  </Modal>
</template>

<script>
import { ButtonClassic, Modal } from "@lde/core_lde_vue";

export default {
  name: "ModalEtablissementIntrouvable",
  components: {
    ButtonClassic,
    Modal,
  },
  props: {
    modalId: {
      type: String,
      required: true,
    },
    contactEmail: {
      type: String,
      default: "ressources.edu@lde.fr",
    },
  },
  computed: {
    mailtoHref() {
      const subject = this.$t(
        "connexion.etablissement-introuvable-modal-mail-subject",
      );
      const body = this.$t(
        "connexion.etablissement-introuvable-modal-mail-body",
      );

      return `mailto:${this.contactEmail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    },
  },
  methods: {
    close() {
      this.$modal.hide(this.modalId);
    },
    openMailto() {
      window.location.href = this.mailtoHref;
    },
  },
};
</script>

<style lang="scss">
.etablissement-introuvable-footer {
  display: flex;
  gap: 0.5rem;
  width: 100%;
  justify-content: flex-end;
}
</style>
